<template>
	<div>
		<div class="channel w">
			<div class="title" v-text="param.title"></div>
			<div class="list">
				<template v-for="(item,index) in param.pic_list">
					<template v-if="item.open_type == 'url'">
						<a :href="item.page_url" target="_blank" class="item" v-if="item.pic_url"><img :src="item.pic_url" alt /></a>
					</template>
					<template v-else>
						<router-link :to="item.page_url" class="item" v-if="item.pic_url"><img :src="item.pic_url" alt /></router-link>
					</template>
				</template>
				<div class="item" v-for="(item,index) in param.list" :key="index">
					<div class="item-t">
						<router-link :to="{path: '/list',query: {id: item.cat_id}}" class="item-name show-one-lines" v-text="item.cat_name"></router-link>
						<span class="show-one-lines flex_1" v-text="item.name"></span>
					</div>
					<div class="item-b">
						<router-link :to="{path:'/pages/goods/goods',query:{id:value.id}}" target="_blank" v-for="(value,key) in item.goods_list" :key="key" class="item-b-img">
							<img :src="value.pic_url" alt />
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.channel {
		.title {
			margin-top: 40px;
			padding-bottom: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28px;
			font-weight: 600;
			box-sizing: border-box;
		}

		.list {
			display: flex;
			flex-wrap: wrap;
			.item {
				width: 387px;
				height: 193px;
				margin-top: 20px;
				background-color: #fff;
				margin-right: 14px;
				&:hover {
					box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
				}

				.item-t {
					display: flex;
					align-items: flex-end;
					padding: 20px 20px 0;
					.item-name {
						max-width: 50%;
						font-size: 18px;
						margin-right: 8px;
					}

					span {
						color: #999999;
					}
				}

				.item-b {
					display: flex;
					margin-top: 16px;
					padding: 0 42px;
					.item-b-img {
						width: 90px;
						height: 90px;

						+.item-b-img {
							margin-left: 14px;
						}
					}
				}
			}
			.item:nth-child(3n){
				margin-right: 0;
			}
		}
	}
</style>
